






























































































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, MacroProduct, MacroProductType, SurveyActionType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { notifyError, notifySuccess } from "@/common/notify";
import { getMacroProducts, deleteMacroProduct, updateMacroProduct } from "@/services";

@Component
export default class MacroProductsManagement extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  products: MacroProduct[] = [];

  clonedProduct: MacroProduct | any = {};

  loading = false;

  filteredData: MacroProduct[] = [];

  selectedRows: MacroProduct[] = [];

  statusOptions = [
    {
      label: "Approvato",
      value: "public",
    },
    // {
    //   label: "Privato",
    //   value: "private",
    // },
    {
      label: "In attesa di approvazione",
      value: "waiting_approval",
    },
  ];

  searchText = "";

  async mounted() {
    try {
      this.products = await getMacroProducts();
      this.setSurveyType(SurveyType.MACRO_PRODUCT);
      this.filteredData = this.products;
    } catch (error) {
      console.log(error);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSelection({ rows, keys, added }: { rows: MacroProduct[]; keys: string[]; added: boolean; evt: object }) {
    if (rows.length === 0) {
      return;
    }

    if (added) {
      let filteredRows = [...rows];

      if (rows.length > 2) {
        filteredRows = rows.slice(0, 2);
      }

      if (this.selectedRows.length < 2) {
        this.selectedRows = [...this.selectedRows, ...filteredRows];
      }
    } else {
      const selectedRows = this.selectedRows.filter(row => rows.indexOf(row) === -1);
      this.selectedRows = [...selectedRows];
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.MACRO_PRODUCT}`).catch(error => console.log(error));
  }

  goToMerge() {
    if (this.selectedRows.length === 2) {
      const mergeID = `${this.selectedRows[0].id}_${this.selectedRows[1].id}`;
      this.$router
        .push(`survey/${SurveyType.MERGE_MACROPRODUCTS}/${mergeID}/${SurveyActionType.NEW}`)
        .catch(error => console.log(error));
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.products.filter(product =>
        product.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.products;
    }
  }

  openShowProduct(product: MacroProduct) {
    this.$router.push(`survey/${SurveyType.MACRO_PRODUCT}/${product.surveys[0].id}`).catch(error => console.log(error));
  }

  async onUpdateProduct(oldProduct: MacroProduct, key: string, product: MacroProduct) {
    try {
      await updateMacroProduct({ name: product.name, status: product.status }, product.id);
      oldProduct.status = product.status;
      notifySuccess("Prodotto turistico aggiornato con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile aggiornare il prodotto turistico!");
    }
  }

  onDeleteProduct(product: MacroProduct) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare il prodotto turistico <strong>${product.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteProductAction(product);
      });
  }

  async deleteProductAction(product: MacroProduct) {
    try {
      await deleteMacroProduct(product.id);
      this.products = await getMacroProducts();
      this.filteredData = this.products;
      this.searchText = "";
      notifySuccess("Prodotto turistico rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il prodotto turistico!");
    }
  }

  cloneRow(product: MacroProduct) {
    this.clonedProduct = { ...product };
  }

  get statusLabelClass() {
    return (status: MacroProductType) => {
      switch (status) {
        case MacroProductType.PUBLIC:
          return "text-positive";
        case MacroProductType.PRIVATE:
          return "text-negative";
        case MacroProductType.WAITING_APPROVAL:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: MacroProductType) => {
      switch (status) {
        case MacroProductType.PUBLIC:
          return "Approvato";
        case MacroProductType.PRIVATE:
          return "Private";
        case MacroProductType.WAITING_APPROVAL:
          return "In attesa di approvazione";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "username",
        label: "Utente",
        align: "left",
        field: (row: MacroProduct) => row.user.name,
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: "status",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
